import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "layout-container"
};
const _hoisted_2 = {
  class: "layout-header"
};
const _hoisted_3 = {
  class: "layout-content"
};
const _hoisted_4 = {
  class: "layout-main"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_IdentityDialog = _resolveComponent("IdentityDialog");
  const _component_GuideDialog = _resolveComponent("GuideDialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createVNode(_component_Header, {
    services: _ctx.serviceList,
    service: _ctx.service,
    onServiceChange: _ctx.onServiceChange
  }, null, 8, ["services", "service", "onServiceChange"])]), _createElementVNode("section", _hoisted_3, [_createElementVNode("main", _hoisted_4, [_ctx.hasIdentity ? (_openBlock(), _createBlock(_component_router_view, {
    key: 0
  })) : _createCommentVNode("", true)])]), _createVNode(_component_IdentityDialog, {
    visible: _ctx.identityDialogVisible,
    services: _ctx.serviceList,
    onClose: _ctx.onClose
  }, null, 8, ["visible", "services", "onClose"]), _createVNode(_component_GuideDialog)]);
}